import React, { CSSProperties } from 'react';

interface EllipsisVerticalProps {
  fill?: string;
  secondaryfill?: string;
  width?: string;
  height?: string;
  style?: CSSProperties;
  className?: string;
}

const EllipsisVertical: React.FC<EllipsisVerticalProps> = ({
  fill = 'currentColor',
  secondaryfill = fill,
  width = '100%',
  height = '100%',
  style,
  className,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 1060 1060"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      className={className}
    >
      <g fill={fill}>
        <defs />
        <path
          className="cls-1"
          d="M530 335.56c-15.34 0-27.78-12.44-27.78-27.78S514.66 280 530 280s27.78 12.44 27.78 27.78-12.44 27.78-27.78 27.78zm0 222.22c-15.34 0-27.78-12.44-27.78-27.78s12.44-27.78 27.78-27.78 27.78 12.44 27.78 27.78-12.44 27.78-27.78 27.78zM530 780c-15.34 0-27.78-12.44-27.78-27.78s12.44-27.78 27.78-27.78 27.78 12.44 27.78 27.78S545.34 780 530 780z"
          fill={fill}
          stroke={fill}
          strokeMiterlimit="10"
          strokeWidth="24px"
        />
      </g>
    </svg>
  );
};

export default EllipsisVertical;